export var CAPTCHA_ENDPOINT = '/captcha.ashx/';
export var CAPTCHA_RESPONSE_TYPE = {
  IMG: 'image/gif',
  JSON: 'application/json'
};
export var DEFAULT_CAPTCHA_WIDTH = 148;
export var DEFAULT_CAPTCHA_HEIGHT = 39;